import { useFeatureValue } from '@growthbook/growthbook-react';
import { FEATURE_FLAG } from '../../../constants/featureFlags';
import { resolveFinpspDepositTypes, type FinpspGatewayOptions } from '../../../helpers/payment/finpspConfig';
import { PAYMENT_GATEWAY } from '../../../types/enums';

export const useFinpspDepositTypes = (paymentProvider: string | null) => {
  const options = useFeatureValue<FinpspGatewayOptions[]>(FEATURE_FLAG.PAYMENT_GATEWAY_OPTIONS, []);
  const gateway = options.find(({ id }) => id === PAYMENT_GATEWAY.FINPSP);

  return resolveFinpspDepositTypes(gateway, paymentProvider);
};
